module.exports = __webpack_public_path__ + "img/event-img-1.b70f66d9.jpg";